class BundleBlock extends HTMLElement {
  constructor() {
    super()
    this.type = this.querySelector('.additional-product-block__products').dataset.type
    this.options = this.querySelectorAll('input')
    this.button = this.querySelector('.additional-product-block__button') ? this.querySelector('.additional-product-block__button') : this
    this.hasButton = this.querySelector('.additional-product-block__button') ? true : false
    this.selectedOptionElement = this.closest('.cto-upsell')?.querySelector('.cto-insurance__selected-option') ? this.closest('.cto-upsell').querySelector('.cto-insurance__selected-option') : false

    this.options.forEach(option => {
      option.addEventListener('change', this.handleChangeOption.bind(this))
    })

    if (this.hasButton) {
      this.button.addEventListener('click', this.handleATCButton.bind(this))
    }
    document.addEventListener('price:updated', this.updateMainPriceWithBundles.bind(this))
  }

  handleChangeOption(event) {
    event.preventDefault()
    let input = event.target
    if (this.type == 'one-option') {
      this.options.forEach(option => {
        if (option != input) {
          option.checked = false
        }
      })
    }
    if (this.selectedOptionElement) {
      this.selectedOptionElement.innerHTML = input.dataset.title
    }
    
    this.handleATCButton('check')
    // if (this.checkOptions() == false) {
    //   this.handleATCButton()
    // }
    if (this.checkOptions() && this.button.classList.contains('additional-product-block__button--added')){
      this.updateMainPriceWithBundles('change')
    }
  }

  handleATCButton(action) {
    let actionType = action == 'check' ? action : 'click'
    let productsSelected = this.checkOptions()
    let isChecked = this.button.classList.contains('additional-product-block__button--added')
    if (!isChecked && !productsSelected) return
    if (isChecked) {
      if (actionType == 'click' || productsSelected == false) {
        this.options.forEach(el => {
          el.checked = false
        })
        if (this.hasButton) {
          this.button.innerHTML = this.button.dataset.add
        }
        this.button.classList.remove('additional-product-block__button--added')
        this.updateMainPriceWithBundles('remove')
      }
    } else {
      if (this.hasButton) {
        this.button.innerHTML = this.button.dataset.added
      }
      this.button.classList.add('additional-product-block__button--added')
      this.updateMainPriceWithBundles('add')
    }
  }

  updateMainPriceWithBundles(operationType) {
    let priceToUpdate = Number(this.getSelectedOptionsPrice())
    let priceElements = document.querySelectorAll('.js-product-price-with-care-warranty.actual_price_bold')
    switch (operationType) {
      case 'remove':
        priceElements.forEach(el => {
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price - Number(this.dataset.addedPrice))   
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(price - Number(this.dataset.addedPrice))   
          }
        })
        this.dataset.addedPrice = ''
        if (this.selectedOptionElement) {
          this.selectedOptionElement.innerHTML = this.selectedOptionElement.dataset.default
        }
        break;
      case 'change':
        priceElements.forEach(el => {
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          let oldPrice = price - Number(this.dataset.addedPrice)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(oldPrice + Number((priceToUpdate / 100).toFixed(2)))
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(oldPrice + Number((priceToUpdate / 100).toFixed(2)))
          }
        })
        this.dataset.addedPrice = Number((priceToUpdate / 100).toFixed(2))
        break;        
      case 'add':
        priceElements.forEach(el => {
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          }
        })
        this.dataset.addedPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
      default:
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let additionalPriceEl = el.querySelector('.js-cto-dynamic-pricing span') ? el.querySelector('.js-cto-dynamic-pricing span') : el.querySelector('.js-cto-dynamic-pricing')
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          if (additionalPriceEl) {
            additionalPriceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
          }
        })
        this.dataset.addedPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
    }
    this.updateNMPPricing(operationType)
  }

  updateNMPPricing(operationType) {
    let priceElements = document.querySelectorAll('.js-product-price-with-care-warranty')
    let priceToUpdate = Number(this.getSelectedOptionsPrice()) / Number(priceElements[0].dataset.priceCalculation)
    switch (operationType) {
      case 'remove':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price - Number(this.dataset.addedNmpPrice))   
        })
        this.dataset.addedNmpPrice = ''
        break;
      case 'change':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          let oldPrice = price - Number(this.dataset.addedNmpPrice)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(oldPrice + Number((priceToUpdate / 100).toFixed(2)))
        })
        this.dataset.addedNmpPrice = Number((priceToUpdate / 100).toFixed(2))
        break;        
      case 'add':
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
        })
        this.dataset.addedNmpPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
      default:
        priceElements.forEach(el => {
          let isNMP = el.closest('.net-monthly-pricing')
          if (!isNMP) return
          let priceEl = el.querySelector('span') ? el.querySelector('span') : el
          let price = this.formatMoney(priceEl.innerHTML)
          priceEl.innerHTML = this.formatPriceWithoutCurrency(price + Number((priceToUpdate / 100).toFixed(2)))   
        })
        this.dataset.addedNmpPrice = Number((priceToUpdate / 100).toFixed(2))
        break;
    }
  }

  formatPriceWithoutCurrency(price) {
    const locale = 'en';
    const currency = 'AED';

    const formattedPrice = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(price);
    return formattedPrice;
  }

  formatMoney(price) {
    if (typeof price === 'number') return price;
    const formattedMoney = price.replace(/[^0-9.-]+/g, '');
    return Number(formattedMoney);
  }

  getSelectedOptionsPrice() {
    let price = 0
    this.options.forEach(option => {
      if (option.checked) {
        price += Number(option.dataset.price)
      }
    })
    return price
  }

  checkOptions() {
    let result = false
    this.options.forEach(option => {
      if (option.checked){
        result = true
      }
    })
    return result
  }

  getProductsToAdd() {
    let productsArray = []
    this.options.forEach(option => {
      if (option.checked){
        let obj = {
          id: option.dataset.id,
          quantity: '1',
          properties: {'_uniq_id': String(Date.now() + Math.floor(Math.random() * 300)), '_is_upsell': true, '_item_key': Date.now() + Math.floor(Math.random() * 300)}
        }
        productsArray.push(obj)
      }
    })
    return productsArray.length != 0 ? productsArray : null
  }
}
customElements.define("bundle-block", BundleBlock);

class CustomTradeIn extends HTMLElement {
  constructor(async){
    super()
    this.object = null
    this.categoryObject = null
    this.selectedOptions = null
    this.selectedObject = null
    this.selectedProduct = []
    this.eventsFlag = false
    this.startTradein = this.querySelector('.custom-trade-in__button') || this.querySelector('.custom-trade-in__cart-button')
    document.addEventListener('open:custom:tradein', this.initDefaultFlow.bind(this))
  }

  registrateListeners() {
    this.querySelectorAll('.modal-trade-in__breadcrumbs').forEach(el => {el.addEventListener('click', this.handleTabClick.bind(this))})
    this.querySelector('[data-step="1"]').addEventListener('click', this.selectCategory.bind(this))
    this.querySelector('[data-step="2"]').addEventListener('click', this.selectBrand.bind(this))
    this.querySelector('[data-step="3"]').addEventListener('click', this.selectModel.bind(this))
    this.querySelector('[data-step="4"]').addEventListener('click', this.selectAttribute.bind(this))
    this.querySelector('[data-step="5"]').addEventListener('click', this.selectGrade.bind(this))
    this.startTradein.addEventListener('click', this.handleAddButtonClick.bind(this))
    this.eventsFlag = true
  }

  selectCategory(event) {
    const item = event.target.classList.contains('custom-trade-in__item') ? event.target : event.target.closest('.custom-trade-in__item')
    if (!item) return
    this.selectedOptions = {}
    this.selectedOptions.category = item.dataset.name
    this.fillTabsBlock()
    this.hideSection('[data-step="1"]')
    this.showBrandSelect()
  }

  selectBrand(event) {
    const item = event.target.classList.contains('custom-trade-in__item') ? event.target : event.target.closest('.custom-trade-in__item')
    if (!item) return
    this.selectedOptions.brand = item.dataset.name
    this.fillTabsBlock('')
    this.hideSection('[data-step="2"]')
    this.showModelSelect()
  }

  selectModel(event) {
    const item = event.target.classList.contains('custom-trade-in__item') ? event.target : event.target.closest('.custom-trade-in__item')
    if (!item) return
    this.selectedOptions.model = item.dataset.name
    this.fillTabsBlock()
    this.hideSection('[data-step="3"]')
    this.showDetailsSelect()
  }

  selectAttribute(event) {
    const item = event.target.classList.contains('custom-trade-in__attributes') ? event.target : event.target.closest('.custom-trade-in__attributes')
    if (!item) return
    const attr = {}
    attr[item.dataset.name] = item.dataset.value
    this.selectedOptions.attributes.push(attr)
    this.fillTabsBlock()
    this.showDetailsSelect()
  }

  selectGrade(event) {
    const item = event.target.classList.contains('custom-trade-in__item--grade') ? event.target : event.target.closest('.custom-trade-in__item--grade')
    if (!item) return
    const buttons = this.querySelectorAll('.custom-trade-in__item--grade')
    buttons.forEach(button => {
      button.classList.remove('active')
    })
    item.classList.add('active')
    this.startTradein.classList.remove('disabled')
  }

  async initDefaultFlow() {
    this.selectedOptions = null
    this.selectedObject = null
    this.selectedProduct = []
    this.fillTabsBlock()
    this.hideCurrentActiveStep()
    this.showLoader()
    if (!this.object) await this.getTradeInObject(false)
    this.transformData()
    if (!this.object.status) {
      this.showErrorMessage()
      return
    }
    this.showDeviceSelect()
    if(!this.eventsFlag) this.registrateListeners()
    this.hideLoader()
  }

  async getTradeInObject(force) {
    const link = force ? '' : 'http://istyle-tradein-worker.istyle-address-autocomplete-proxy.workers.dev/'
    try {
      const response = await fetch(link);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      this.object = data
    } catch (error) {
      console.error(error);
      this.showErrorMessage()
    }
  }

  transformData() {
    if (!this.object) return
    if (!this.object?.status && this.object?.statusCode != 200) this.showErrorMessage()
    const filteredData = {}
    const categoryObj = {}
    const skuArray = this.object.data.sku
    for (let i = 0; i < skuArray.length; i++) {
      const item = skuArray[i];

      const category = item.category?.name?.en || '';
      const normalizedCategory = category.replace(/\s?"/g, '').trimEnd();
      const brand = item.brand?.name?.en || '';
      const normalizedBrand = brand.replace(/\s?"/g, '').trimEnd();
      if (!categoryObj[normalizedCategory]) {
        categoryObj[normalizedCategory] = {};
      }
      if (!categoryObj[normalizedCategory][normalizedBrand]) {
        categoryObj[normalizedCategory][normalizedBrand] = [];
      }
      categoryObj[normalizedCategory][normalizedBrand].push(item);
    }
    this.categoryObject = categoryObj
  }

  fillTabsBlock() {
    const tabs = this.querySelector('.modal-trade-in__breadcrumbs')
    tabs.innerHTML = ''
    if (!this.selectedOptions) return
    for (const key in this.selectedOptions) {
      if (Array.isArray(this.selectedOptions[key])) {
        for (let i = 0; i < this.selectedOptions[key].length; i++) {
          let item = this.selectedOptions[key][i]
          let itemKey = Object.keys(item)[0] 
          let itemValue = Object.values(item)[0] 
          const element = `<div class="modal-trade-in__breadcrumb" data-key="attributes" data-key='${itemKey}' data-value='${itemValue}' >${itemValue}</div>`
          tabs.innerHTML += element
        }
      } else {
        const element = `<div class="modal-trade-in__breadcrumb" data-key='${key}'>${this.selectedOptions[key]}</div>`
        tabs.innerHTML += element
      }
    }
  }

  showDeviceSelect() {
    if (!this.categoryObject) return
    const categoryWrapper = this.querySelector('[data-step="1"]')
    categoryWrapper.querySelectorAll('.custom-trade-in__item').forEach(el => {el.classList.add('hidden')})
    for (const key in this.categoryObject) {
      const selector = categoryWrapper.querySelector(`[data-name="${key}"]`)
      if (selector) selector.classList.remove('hidden')
    }
    categoryWrapper.classList.add('step-active')
  }

  showBrandSelect() {
    if (!this.selectedOptions && !this.selectedOptions.category) return
    const brandWrapper = this.querySelector('[data-step="2"]')
    brandWrapper.innerHTML = ''
    const brandObj = this.categoryObject[this.selectedOptions.category]
    for (const key in brandObj) {
      const element = `<li class="custom-trade-in__item" data-name="${key}"><div class="custom-trade-in__item-title">${key}</div></li>`
      brandWrapper.innerHTML += element
    }
    brandWrapper.classList.add('step-active')
  }

  showModelSelect() {
    this.selectedObject = this.generateCurrentObject()
    if (!this.selectedObject) return
    const modelWrapper = this.querySelector('[data-step="3"]')
    modelWrapper.innerHTML = ''
    const uniqModelArray = []
    for (let i = 0; i < this.selectedObject.length; i++) {
      const item = this.selectedObject[i]
      if (uniqModelArray.includes(item.model.name.en)) continue;
      if (item.model.name.en.indexOf('alert') != -1) continue;
      const model = `<li class="custom-trade-in__item" data-name="${item.model.name.en}">
        <div class="custom-trade-in__item-title">${item.model.name.en}</div>
      </li>`
      uniqModelArray.push(item.model.name.en)
      modelWrapper.innerHTML += model
    }
    modelWrapper.classList.add('step-active')
  }

  showDetailsSelect() {
    const detailsObject = this.generateCurrentObject()
    if (!this.selectedOptions.attributes) this.selectedOptions.attributes = []
    const selectedAttributes = this.selectedOptions.attributes
    const detailsWrapper = this.querySelector('[data-step="4"]')  
    detailsWrapper.innerHTML = ''
    let attributesArray = []
    for (let i = 0; i < detailsObject.length; i++) {
      const element = detailsObject[i]
      const attributes = element.attributes
      if (attributes.length == selectedAttributes.length) {
        this.selectedProduct = detailsObject
        this.showGrade()
        return
      }
      const selectedNames = selectedAttributes.map(attr => Object.keys(attr)[0]);
      const attributesToRender = attributes.find(attr => !selectedNames.includes(attr.label.en));
      if (attributesArray.includes(attributesToRender.value.en)) continue
      let attribute = `<div class="custom-trade-in__attributes" data-name='${attributesToRender.label.en}' data-value='${attributesToRender.value.en}'>
        <span class="custom-trade-in__attribute">${attributesToRender.value.en}</span>
      </div>`
      attributesArray.push(attributesToRender.value.en)
      detailsWrapper.innerHTML += attribute
    }
    detailsWrapper.classList.add('step-active')
  }

  showGrade() {
    if (this.selectedProduct.length == 0) return
    const gradeWrapper = this.querySelector('[data-step="5"] .custom-trade-in__list')
    this.hideSection('[data-step="4"]')
    gradeWrapper.innerHTML = ''
    const selectedProduct = this.selectedProduct[0]
    for (let i = 0; i < selectedProduct.descriptionByGrade.length; i++) {
      const grade = selectedProduct.descriptionByGrade[i]
      let conditions = ''
      for (let k = 0; k < grade.condition.length; k++) {
        const condition = grade.condition[k]
        conditions += `<li class="grade__condition-item">${condition.en}</li>`
      }
      const gradePrice = selectedProduct.priceByGrade.find(el => el.id == grade.id)
      let gradeBlock = `<li class="custom-trade-in__item custom-trade-in__item--grade" data-id="${grade.id}">
        <div class="grade__item">
          <div class="grade__header">
            <span class="grade__title">${grade.label.en}</span>
            <span class="grade__price">AED ${gradePrice.price.toFixed(2)}</span>
          </div>
          <ul class="grade__condition-list list-unstyled">${conditions}</ul>
        </div>
      </li>`
      gradeWrapper.innerHTML += gradeBlock
    }
    gradeWrapper.closest('[data-step="5"]').classList.add('step-active')
  }

  generateCurrentObject() {
    if (!this.selectedOptions && !this.selectedOptions.category) return this.categoryObject
    const selectedCategoryObj = this.categoryObject[this.selectedOptions.category]
    if (selectedCategoryObj && !this.selectedOptions.brand) return selectedCategoryObj
    const selectedBrandObj = selectedCategoryObj[this.selectedOptions.brand]
    if (selectedBrandObj && !this.selectedOptions.model) return selectedBrandObj
    const selectedModelObj = selectedBrandObj.filter(el => el.model.name.en == this.selectedOptions.model)
    if (selectedModelObj && !this.selectedOptions.attributes) return selectedModelObj
    if (selectedModelObj && this.selectedOptions.attributes) {
      const selectedAttributesObj = this.generateAttributeObj(selectedModelObj)
      return selectedAttributesObj
    }
  }

  generateAttributeObj(obj) {
    return obj.filter(product => {
      if (this.selectedOptions.attributes) {
        const productAttributes = Object.fromEntries(product.attributes.map(attr => [attr.label.en, attr.value.en]));
        for (const attribute of this.selectedOptions.attributes) {
          const [label, value] = Object.entries(attribute)[0];
          if (productAttributes[label] !== value) {
            return false;
          }
        }
      }
      return true;
    });
  }

  handleTabClick(event) {
    if (!this.startTradein.classList.contains('disabled')) this.startTradein.classList.add('disabled');
    const item = event.target.classList.contains('modal-trade-in__breadcrumb') ? event.target : event.target.closest('.modal-trade-in__breadcrumb')
    if (!item) return
    const key = item.dataset.key
    if (!key) return
    if (key == 'attributes') {
      const value = item.dataset.value
      const attrs = [...this.selectedOptions.attributes]
      for (let i = 0; i < attrs.length; i++) {
        const obj = attrs[i]
        const objValue = Object.values(obj)[0]
        
        if (objValue == value) {
          attrs.splice(i, 1);
          break
        }
      }
      this.selectedOptions.attributes = attrs
      if (this.selectedOptions.attributes.length == 0) delete this.selectedOptions.attributes
    }
    switch (key) {
      case 'category':
        this.selectedOptions = null
        this.hideCurrentActiveStep()
        this.showDeviceSelect()
        break;
      case 'brand':
        delete this.selectedOptions.brand
        delete this.selectedOptions.model
        delete this.selectedOptions.attributes
        this.hideCurrentActiveStep()
        this.showBrandSelect()
        break;
      case 'model':
        delete this.selectedOptions.model
        delete this.selectedOptions.attributes
        this.hideCurrentActiveStep()
        this.showModelSelect()
        break;
      case 'attributes':
        this.hideCurrentActiveStep()
        this.fillTabsBlock()
        this.showDetailsSelect()
        break;
    }
    this.fillTabsBlock()
  }
  
  showLoader() {
    this.classList.add('loaded')
  }

  hideLoader() {
    this.classList.remove('loaded')
  }

  hideSection(query) {
    this.querySelector(query).classList.remove('step-active')
  }

  hideCurrentActiveStep() {
    this.querySelectorAll('[data-step]').forEach(el => {
      if (el.classList.contains('step-active')) {
        el.classList.remove('step-active')
      }
    })
  }

  showErrorMessage() {
    this.hideCurrentActiveStep()
    this.querySelector('.custom-trade-in__list--error[data-step="0"]').classList.add('step-active')
    if (this.object?.message) {
      this.querySelector('.custom-trade-in__list--error[data-step="0"]').innerHTML = this.object.message
    } else {
      this.querySelector('.custom-trade-in__list--error[data-step="0"]').innerHTML = 'Something went wrong.</br> Please try again later.'
    }
  }

  handleAddButtonClick(){
    if (this.startTradein.classList.contains('disabled')) return
    const product = this.selectedProduct[0]
    if (!product) return
    const gradeId = this.querySelector('.custom-trade-in__item--grade.active').dataset.id
    if (this.startTradein.classList.contains('custom-trade-in__cart-button')) {
      this.startTradein.dataset.tradeInProduct = product.descriptiveLabel.en.replace(/"/g, "″")
      this.startTradein.dataset.tradeInId = product.id
      this.startTradein.dataset.tradeInGrade = gradeId
      this.startTradein.dataset.tradeInPrice = product.priceByGrade.find(item => item.id == gradeId).price
      this.startTradein.classList.add('add-cart-custom-trade-in')
      this.startTradein.click()
      this.showLoader()
      return
    }
    document.querySelector('#selected-trade-in-product').value = product.descriptiveLabel.en.replace(/"/g, "″")
    document.querySelector('#selected-trade-in-id').value = product.id
    document.querySelector('#selected-trade-in-grade').value = gradeId
    document.querySelector('#selected-trade-in-price').value = product.priceByGrade.find(item => item.id == gradeId).price
    const successMessage = document.querySelector('.custom-trade-in__pdp-success')
    if (successMessage) {
      successMessage.querySelector('.pdp-value-amount').innerHTML = 'AED ' + product.priceByGrade.find(item => item.id == gradeId).price.toFixed(2)
      successMessage.classList.remove('hidden')
    }
    this.closest('[data-modal-element-overlay-container]').querySelector('[data-modal-element-close-button]').click()
  }
}
customElements.define('custom-trade-in', CustomTradeIn)